<template>
  <v-container fluid>
    <v-slide-y-transition mode="out-in">
      <v-layout column align-center>
        <img src="@/assets/logo.png" alt="Vuetify.js" class="mb-5">
        <v-flex class="headline">First, solve the problem. Then, write the code.
          <footer class="subheading">
            <!-- <small> -->
              <em>John Johnson</em>
            <!-- </small> -->
          </footer>
        </v-flex >
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>
<script>
import { ParametrosModel } from "@/models/generales/parametros";
import ParametrosAPI from "@/services/generales/parametros";
import HomeAPI from "@/services/home";
import { getIdFromURL, getTimeFromURL } from 'vue-youtube-embed';
import {isNotEmpty, isEmpty} from "@/helpers/validators";
import {EventBus} from '@/events/event-bus';
import * as events from '@/constants/event-names';

export default {
  name: "Feeds"
  , head: {
    title: function() {
      return {
        inner: this.view.title,
        separator: "|"
        , complement: this.$t("view.home.system.initials")
      };
    }
  }
  , data() {
    return {
      
      view: {
        title: "Inicio"
        , action:{
          getNews:{
            busy:false
          }
        }
        , message:{
          noMoreResults:{
            visible:false
          }
        }
        , button:{
          showMore:{
            visible:false
          }
        }
      }
    };
  }
  , methods: {    
    async loadParametros(){
      try{
        const response = await ParametrosAPI.get({clave:1});
      }catch(error){
      }
    }
    , async setInitialState(){
      try{
        
      }catch(error){
        console.log(error);
      }
    }
    
    
  }
  , mounted(){
    this.setInitialState();
    this.loadParametros()
    
   
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/views/home/Feeds.vue